import { render, staticRenderFns } from "./confirmation-review-modal.vue?vue&type=template&id=0ff8c18e"
import script from "./confirmation-review-modal.ts?vue&type=script&lang=ts&external"
export * from "./confirmation-review-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./confirmation-review-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff8c18e')) {
      api.createRecord('0ff8c18e', component.options)
    } else {
      api.reload('0ff8c18e', component.options)
    }
    module.hot.accept("./confirmation-review-modal.vue?vue&type=template&id=0ff8c18e", function () {
      api.rerender('0ff8c18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/confirmation-review-modal/confirmation-review-modal.vue"
export default component.exports